var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{attrs:{"for":_vm.id}},[_c('input',{attrs:{"type":"checkbox","id":_vm.id},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.checked)}}}),_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/shared/components/Checkbox.vue?vue&type=template&id=1f09911c&
// module id = null
// module chunks = 